import { Injectable } from '@angular/core';
import { DailyparamsService } from './dailyparams.service';
import { BodychangeService } from './bodychange.service';

@Injectable({
  providedIn: 'root'
})
export class BodymodelService {

  RK4wt; fat; lean; glycogen; decw; therm; DailyParams; BodyChange;

  constructor( dailyParams: DailyparamsService, bodyChange: BodychangeService ) {
    this.DailyParams = dailyParams;
    this.BodyChange = bodyChange;
    this.BodyModel(null,null,null,null,null);
  }

  BodyModel = (fat, lean, glycogen, decw, therm) => {
    this.RK4wt = [1, 2, 2, 1];
    this.fat = fat || 0;
    this.lean = lean || 0;
    this.glycogen = glycogen || 0;
    this.decw = decw || 0;
    this.therm = therm || 0;
};

  spawnFromBodyModel = (fat, lean, glycogen, decw, therm):BodymodelService => {
    let bm = new BodymodelService(this.DailyParams, this.BodyChange);
    bm.BodyModel(fat, lean, glycogen, decw, therm);
    return bm;
  }

  createFromBaseline = (baseline):BodymodelService => {
    return this.spawnFromBodyModel(
      baseline.getFatWeight(),
      baseline.getLeanWeight(),
      baseline.glycogen, 
      baseline.dECW,
      baseline.getTherm());
  };

  projectFromBaseline = (baseline, dailyParams, simlength) => {
    var loop = this.createFromBaseline(baseline);
    for (var i = 0; i < simlength; i++) {
      loop = this.RungeKatta(loop, baseline, dailyParams);
    }
    return loop;
  };

  projectFromBaselineViaIntervention = (baseline, intervention, simlength) => {
    let dailyParams =  this.DailyParams.createFromIntervention(intervention, baseline);
    return this.projectFromBaseline(baseline, dailyParams, simlength);
  };

  getWeight = (baseline) => {
    var weight = this.fat + this.lean + baseline.getGlycogenH2O(this.glycogen) + this.decw;
    return weight
  };

  getapproxWeight = () => {
    return this.fat + this.lean + this.decw;
  };

  getFatFree = (baseline) => {
    return this.getWeight(baseline) - this.fat;
  };

  getFatPercent = (baseline) => {
    return this.fat / this.getWeight(baseline) * 100.0;
  };

  getBMI = (baseline) => {
    return baseline.getNewBMI(this.getWeight(baseline));
  };

  dt = (baseline, dailyParams) => {
    var df = this.dfdt(baseline, dailyParams),
      dl = this.dldt(baseline, dailyParams),
      dg = this.dgdt(baseline, dailyParams),
      dDecw = this.dDecwdt(baseline, dailyParams),
      dtherm = this.dthermdt(baseline, dailyParams);

    return this.BodyChange.spawnFromBodyChange(df, dl, dg, dDecw, dtherm);
  };

  RungeKattaAveraged = (bodyModel, baseline, dailyParams1, dailyParams2) => {
    let midailyParams = dailyParams2.isramped() ? dailyParams2 : this.DailyParams.avg(dailyParams1, dailyParams2),
      dt1 = bodyModel.dt(baseline, dailyParams1),
      b2 = bodyModel.addchange(dt1, 0.5),
      dt2 = b2.dt(baseline, midailyParams),
      b3 = bodyModel.addchange(dt2, 0.5),
      dt3 = b3.dt(baseline, midailyParams),
      b4 = bodyModel.addchange(dt3, 1.0),
      dt4 = b4.dt(baseline, dailyParams2),
      finaldt = bodyModel.avgdt_weighted(this.RK4wt, [dt1, dt2, dt3, dt4]),
      finalstate = bodyModel.addchange(finaldt, 1.0);

    return finalstate;
  };

  RungeKatta = (bodyModel, baseline, dailyParams) => {

    var dt1 = bodyModel.dt(baseline, dailyParams),
      b2 = bodyModel.addchange(dt1, 0.5),
      dt2 = b2.dt(baseline, dailyParams),
      b3 = bodyModel.addchange(dt2, 0.5),
      dt3 = b3.dt(baseline, dailyParams),
      b4 = bodyModel.addchange(dt3, 1.0),
      dt4 = b4.dt(baseline, dailyParams),
      finaldt = bodyModel.avgdt_weighted(this.RK4wt, [dt1, dt2, dt3, dt4]),
      finalstate = bodyModel.addchange(finaldt, 1.0);
    return finalstate;
  };

  Euler = (bodyModel, baseline, dailyParams) => {
    var dt1 = bodyModel.dt(baseline, dailyParams);
    return bodyModel.addchange(dt1, 1.0);
  };

  getTEE = (baseline, dailyParams) => {
    var p = this.getp(),
      calin = dailyParams.calories,
      carbflux = this.carbflux(baseline, dailyParams),
      Expend = this.getExpend(baseline, dailyParams);
    return (Expend + (calin - carbflux) * ((1.0 - p) * 180.0 / 9440.0 + p * 230.0 / 1807.0)) / (1.0 + p * 230.0 / 1807.0 + (1.0 - p) * 180.0 / 9440.0);

  };

  getExpend = (baseline, dailyParams) => {
    var TEF = 0.1 * dailyParams.calories,
      weight = baseline.getNewWeightFromBodyModel(this);
    return baseline.getK() + 22.0 * this.lean + 3.2 * this.fat + dailyParams.actparam * weight + this.therm + TEF;
  };

  getp = () => {
    return 1.990762711864407 / (1.990762711864407 + this.fat);
  };

  carbflux = (baseline, dailyParams) => {
    var k_carb = baseline.getCarbsIn() / Math.pow(baseline.glycogen, 2.0);
    return dailyParams.getCarbIntake() - k_carb * Math.pow(this.glycogen, 2.0);
  };

  Na_imbal = (baseline, dailyParams) => {
    return dailyParams.sodium - baseline.sodium - 3000.0 * this.decw - 4000.0 * (1.0 - dailyParams.getCarbIntake() / baseline.getCarbsIn());
  };

  dfdt = (baseline, dailyParams) => {
    var dfdt = (1.0 - this.getp()) * (dailyParams.calories - this.getTEE(baseline, dailyParams) - this.carbflux(baseline, dailyParams)) / 9440.0;
    return dfdt;
  };

  dldt = (baseline, dailyParams) => {
    var dldt = this.getp() * (dailyParams.calories - this.getTEE(baseline, dailyParams) - this.carbflux(baseline, dailyParams)) / 1807.0;
    return dldt;
  };

  dgdt = (baseline, dailyParams) => {
    return this.carbflux(baseline, dailyParams) / 4180.0;
  };

  dDecwdt = (baseline, dailyParams) => {
    return this.Na_imbal(baseline, dailyParams) / 3220.0;
  };

  dthermdt = (baseline, dailyParams) => {
    return (0.14 * dailyParams.calories - this.therm) / 14.0;
  };

  addchange = (bchange, tstep) => {
    return  this.spawnFromBodyModel(
      this.fat + tstep * bchange.df,
      this.lean + tstep * bchange.dl,
      this.glycogen + tstep * bchange.dg,
      this.decw + tstep * bchange.dDecw,
      this.therm + tstep * bchange.dtherm
    );
  };

  cals4balance = (baseline, act) => {
    var weight = this.getWeight(baseline),
      Expend_no_food = baseline.getK() + 22.0 * this.lean + 3.2 * this.fat + act * weight,
      p = this.getp(),
      p_d = 1.0 + p * 230.0 / 1807.0 + (1.0 - p) * 180.0 / 9440.0,
      p_n = (1.0 - p) * 180.0 / 9440.0 + p * 230.0 / 1807.0,
      maint_nocflux = Expend_no_food / (p_d - p_n - 0.24);

    return maint_nocflux;
  };

  Bodytraj = (baseline, paramtraj) => {
    var simlength = paramtraj.length,
      bodytraj = [];

    bodytraj.push(this.createFromBaseline(baseline));

    for (var i = 1; i < simlength; i++)
      // NVS: somehow this was always using too many params??
      //bodytraj.push(this.RungeKatta(bodytraj[(i - 1)], baseline, paramtraj[(i - 1)], paramtraj[i]));
      bodytraj.push(this.RungeKatta(bodytraj[(i - 1)], baseline, paramtraj[(i - 1)]));

    return bodytraj;
  };

  avgdt = (bchange) => {
    var sumf = 0.0,
      suml = 0.0,
      sumg = 0.0,
      sumdecw = 0.0,
      sumtherm = 0.0;

    for (var i = 0; i < bchange.length; i++) {
      sumf += bchange[i].df;
      suml += bchange[i].dl;
      sumg += bchange[i].dg;
      sumdecw += bchange[i].dDecw;
      sumtherm += bchange[i].dtherm;
    }

    var nf = sumf / bchange.length,
      nl = suml / bchange.length,
      ng = sumg / bchange.length,
      ndecw = sumdecw / bchange.length,
      ntherm = sumtherm / bchange.length;

    return this.BodyChange.spawnFromBodyChange(nf, nl, ng, ndecw, ntherm);
  };

  avgdt_weighted = (wt, bchange) => {
    var sumf = 0.0,
      suml = 0.0,
      sumg = 0.0,
      sumdecw = 0.0,
      sumtherm = 0.0,
      wti = 0,
      wtsum = 0;

    for (var i = 0; i < bchange.length; i++) {
      try {
        wti = wt[i];
      }
      catch (e) {
        wti = 1;
      }

      wti = (wti < 0) ? 1 : wti;
      wtsum += wti;
      sumf += wti * bchange[i].df;
      suml += wti * bchange[i].dl;
      sumg += wti * bchange[i].dg;
      sumdecw += wti * bchange[i].dDecw;
      sumtherm += wti * bchange[i].dtherm;
    }

    var nf = sumf / wtsum,
      nl = suml / wtsum,
      ng = sumg / wtsum,
      ndecw = sumdecw / wtsum,
      ntherm = sumtherm / wtsum;

    return this.BodyChange.spawnFromBodyChange(nf, nl, ng, ndecw, ntherm);
  };
}
